import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

const ConnectedProgressBar = (props) => {
  const { ProgressBar } = props;
  const progressDefined = Number.isFinite(props.progress);

  return (progressDefined) ? <ProgressBar { ...props } /> : null;
};

ConnectedProgressBar.propTypes={
  ProgressBar: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  progress: PropTypes.number,
};

export default connect( (state) => {
  const {
    progress: { total, reverse } = {}
  } = state;

  return {
    progress: total,
    reverse
  };
})(ConnectedProgressBar);
